// ── Clinic configuration ──────────────────────────────────────────────────────
// Change any value here to update it across the entire app.

export const CLINIC_NAME     = 'Vijayas Dental Care';
export const CLINIC_SUBTITLE = 'Managing system';
export const CLINIC_TAGLINE  = '827/A 5th Main Road, Kollidam 9092131736';

// Shown in the billing print header — update these to your clinic's details
export const CLINIC_ADDRESS  = '827/A 5th Main Road, Kollidam';
export const CLINIC_PHONE    = '+91 9092131736';
export const CLINIC_EMAIL    = '';   // optional — leave blank to hide
